<dx-box height="100%" width="100%" direction="col">
    <dxi-item [visible]="!!pdfSource" [ratio]="1">
        <div *dxTemplate>
            <iframe
                *ngIf="!!pdfSource"
                [src]="pdfSource"
                height="100%"
                width="100%"
                id="loaderPanel"
                title="Time & Expense Submission Report"
            ></iframe>
        </div>
    </dxi-item>
    <dxi-item [visible]="!pdfSource" [ratio]="1">
        <div *dxTemplate>
            <div *ngIf="!pdfSource" class="loader-panel dx-theme-accent-as-text-color" id="loaderPanel"></div>
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel
    *ngIf="loader"
    [position]="{ of: '#loaderPanel' }"
    [visible]="loader"
    [showIndicator]="true"
    [showPane]="false"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
